import React, { useState, useEffect } from "react";
import {
  FaPlus,
  FaUser,
  FaLaptop,
  FaDesktop,
  FaMobile,
  FaTabletAlt,
  FaPrint,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaShieldAlt,
  FaSave,
  FaFileAlt,
  FaVirus,

  FaLock,
  FaCompactDisc,
  FaCheck,
  FaTimes as FaTimesIcon
} from "react-icons/fa";
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { RadioButton } from 'primereact/radiobutton';
import { InputTextarea } from 'primereact/inputtextarea';

// PrimeReact CSS
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';

function AddAudit({ handleTambahAudit, isModalOpen, setIsModalOpen, form, setForm, form2, setForm2, postData, isEditMode, resetForm }) {
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = '';
      };
    }
  }, [isModalOpen]);

  const jenisPerangkatOptions = [
    { value: "Laptop", icon: FaLaptop, color: "text-blue-600" },
    { value: "Desktop", icon: FaDesktop, color: "text-green-600" },
    { value: "Tablet", icon: FaTabletAlt, color: "text-purple-600" },
    { value: "Mobile", icon: FaMobile, color: "text-orange-600" }
  ];

  const lokasiOptions = [
    "Ruang Guru",
    "Ruang Kerja",
    "Perpustakaan",
    "Ruang Server",
    "Ruang Kelas"
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ""
      }));
    }
  };

  const handleForm2Change = (e) => {
    const { name, value } = e.target;
    setForm2(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // ==================== RADIO HANDLERS ====================

  // Handler untuk radio antivirus status
  const handleAntivirusStatus = (value) => {
    setForm2(prev => ({
      ...prev,
      antivirus: value === 'tidak_ada' ? 'tidak_ada' : 'ada'
    }));
  };

  // Handler untuk radio antivirus update
  const handleAntivirusUpdate = (value) => {
    setForm2(prev => ({
      ...prev,
      antivirus: `ada,${value}`
    }));
  };

  // Handler untuk radio firewall status
  const handleFirewallStatus = (value) => {
    setForm2(prev => ({
      ...prev,
      firewall: value === 'tidak_ada' ? 'tidak_ada' : 'ada'
    }));
  };

  // Handler untuk radio firewall update
  const handleFirewallUpdate = (value) => {
    setForm2(prev => ({
      ...prev,
      firewall: `ada,${value}`
    }));
  };

  // Handler untuk radio enkripsi/password status
  const handleEnkripsiStatus = (value) => {
    setForm2(prev => ({
      ...prev,
      enkripsi: value === 'tidak' ? 'tidak' : 'ya'
    }));
  };

  // Handler untuk radio enkripsi strength
  const handleEnkripsiStrength = (value) => {
    setForm2(prev => ({
      ...prev,
      enkripsi: `ya,${value}`
    }));
  };

  // Handler untuk radio so_update
  const handleSoUpdateStatus = (value) => {
    setForm2(prev => ({
      ...prev,
      so_update: value
    }));
  };

  // Helper: cek apakah field mengandung value tertentu
  const hasValue = (fieldName, value) => {
    const fieldValue = form2[fieldName];
    if (!fieldValue) return false;
    return fieldValue.split(',').includes(value);
  };

  // Helper: cek status utama field
  const getMainStatus = (fieldName) => {
    const fieldValue = form2[fieldName];
    if (!fieldValue) return '';
    return fieldValue.split(',')[0];
  };

  const validateForm = () => {
    const newErrors = {};

    // Validasi form utama
    if (!form.gupeg || !form.gupeg.trim()) newErrors.gupeg = "Nama pegawai wajib diisi";
    if (!form.nip || !form.nip.trim()) newErrors.nip = "NIP wajib diisi";
    if (!form.jenis_perangkat) newErrors.jenis_perangkat = "Jenis perangkat wajib dipilih";
    if (!form.model || !form.model.trim()) newErrors.model = "Model perangkat wajib diisi";
    if (!form.so || !form.so.trim()) newErrors.so = "Sistem operasi wajib diisi";
    if (!form.tgl) newErrors.tgl = "Tanggal audit wajib diisi";
    if (!form.lokasi) newErrors.lokasi = "Lokasi wajib dipilih";


    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateForm();

    if (isValid) {
      const combinedData = {
        ...form,
        proses_audit: form2
      };

      try {
        setIsSubmitting(true);
        await postData();
        setIsModalOpen(false);
        if (handleTambahAudit) {
          handleTambahAudit(combinedData);
        }
      } catch (error) {
        console.error("Error saat menyimpan data:", error);
      } finally {
        setIsSubmitting(false);
      }
    } else {
      console.log("Form validation failed!");
      console.log("Errors:", errors);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    if (resetForm) {
      resetForm();
    }
  };

  return (
    <>
      {/* Tombol Tambah Audit */}
      <Button
        onClick={() => setIsModalOpen(true)}
        icon={<FaPlus />}
        label="Tambah Audit"
        className="flex items-center gap-2 bg-primary text-white rounded-2xl hover:bg-primary/90 transition-all duration-200 shadow-md hover:shadow-lg px-6 py-3 font-semibold"
      />

      <Dialog
        visible={isModalOpen}
        onHide={handleCloseModal}
        header={
          <div className="flex min-w-0 items-center gap-3 pr-6">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-white/15">
              <FaShieldAlt className="text-lg text-white" />
            </span>
            <div className="min-w-0">
              <h2 className="truncate text-base font-semibold text-white sm:text-lg">
                {isEditMode ? "Edit audit keamanan" : "Audit keamanan baru"}
              </h2>
              <p className="truncate text-xs text-white/75">
                Pegawai, perangkat, dan hasil pemeriksaan
              </p>
            </div>
          </div>
        }
        footer={
          <div className="flex w-full flex-col-reverse gap-2 sm:flex-row sm:justify-end">
            <button
              type="button"
              onClick={handleCloseModal}
              disabled={isSubmitting}
              className="audit-cancel w-full sm:w-auto"
            >
              Batal
            </button>
            <button
              type="submit"
              form="audit-form"
              disabled={isSubmitting}
              className="audit-save w-full sm:w-auto"
            >
              {!isSubmitting && <FaSave className="h-4 w-4" />}
              <span>{isSubmitting ? "Menyimpan..." : (isEditMode ? "Perbarui" : "Simpan audit")}</span>
            </button>
          </div>
        }
        className="audit-dialog-fullscreen"
        maskClassName="audit-dialog-mask"
        headerClassName="bg-primary text-white"
        modal
        blockScroll
        draggable={false}
        resizable={false}
        closable
        appendTo={document.body}
        baseZIndex={9999}
      >
        <div className="mx-auto w-full max-w-5xl px-3 py-4 sm:px-5 sm:py-5">
          <form id="audit-form" onSubmit={handleSubmit} className="space-y-4">
              {/* Informasi Pegawai */}
              <div className="rounded-2xl border border-slate-100 bg-white p-4 shadow-sm sm:p-5">
                <h3 className="mb-4 flex items-center gap-3 text-base font-semibold text-slate-800">
                  <div className="p-3 bg-primary rounded-xl">
                    <FaUser className="text-white text-lg" />
                  </div>
                  <span className="text-primary">
                    Informasi Pegawai
                  </span>
                </h3>
                <div className="grid grid-cols-1 gap-4 tablet:grid-cols-2">
                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                      <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                      Nama Pegawai *
                    </label>
                    <InputText
                      name="gupeg"
                      value={form.gupeg || ""}
                      onChange={handleInputChange}
                      className={`w-full p-4 rounded-xl border-2 transition-all duration-300 ${errors.gupeg ? 'p-invalid border-red-300' : 'border-gray-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100'}`}
                      placeholder="Masukkan nama lengkap pegawai"
                    />
                    {errors.gupeg && (
                      <small className="p-error text-red-600 font-medium">{errors.gupeg}</small>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                      <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                      NIP *
                    </label>
                    <InputText
                      name="nip"
                      value={form.nip || ""}
                      onChange={handleInputChange}
                      className={`w-full p-4 rounded-xl border-2 transition-all duration-300 ${errors.nip ? 'p-invalid border-red-300' : 'border-gray-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100'}`}
                      placeholder="Masukkan NIP pegawai"
                    />
                    {errors.nip && (
                      <small className="p-error text-red-600 font-medium">{errors.nip}</small>
                    )}
                  </div>
                </div>
              </div>

              {/* Informasi Perangkat */}
              <div className="rounded-2xl border border-slate-100 bg-white p-4 shadow-sm sm:p-5">
                <h3 className="mb-4 flex items-center gap-3 text-base font-semibold text-slate-800">
                  <div className="p-3 bg-accent rounded-xl">
                    <FaLaptop className="text-white text-lg" />
                  </div>
                  <span className="text-accent-600">
                    Informasi Perangkat
                  </span>
                </h3>
                <div className="grid grid-cols-1 gap-4 tablet:grid-cols-2 xl:grid-cols-3">
                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                      <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                      Jenis Perangkat *
                    </label>
                    <Dropdown
                      name="jenis_perangkat"
                      value={form.jenis_perangkat || ""}
                      onChange={handleInputChange}
                      options={jenisPerangkatOptions}
                      optionLabel="value"
                      optionValue="value"
                      placeholder="Pilih jenis perangkat"
                      appendTo={document.body}
                      className={`w-full ${errors.jenis_perangkat ? "p-invalid" : ""}`}
                    />
                    {errors.jenis_perangkat && (
                      <small className="p-error text-red-600 font-medium">{errors.jenis_perangkat}</small>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                      <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                      Model Perangkat *
                    </label>
                    <InputText
                      name="model"
                      value={form.model || ""}
                      onChange={handleInputChange}
                      className={`w-full p-4 rounded-xl border-2 transition-all duration-300 ${errors.model ? 'p-invalid border-red-300' : 'border-gray-200 focus:border-green-500 focus:ring-4 focus:ring-green-100'}`}
                      placeholder="Contoh: Dell Latitude 5520"
                    />
                    {errors.model && (
                      <small className="p-error text-red-600 font-medium">{errors.model}</small>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                      <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                      Sistem Operasi *
                    </label>
                    <InputText
                      name="so"
                      value={form.so || ""}
                      onChange={handleInputChange}
                      className={`w-full p-4 rounded-xl border-2 transition-all duration-300 ${errors.so ? 'p-invalid border-red-300' : 'border-gray-200 focus:border-green-500 focus:ring-4 focus:ring-green-100'}`}
                      placeholder="Contoh: Windows 11 Pro"
                    />
                    {errors.so && (
                      <small className="p-error text-red-600 font-medium">{errors.so}</small>
                    )}
                  </div>
                </div>
              </div>

              {/* Informasi Audit */}
              <div className="rounded-2xl border border-slate-100 bg-white p-4 shadow-sm sm:p-5">
                <h3 className="mb-4 flex items-center gap-3 text-base font-semibold text-slate-800">
                  <div className="p-3 bg-primary/80 rounded-xl">
                    <FaCalendarAlt className="text-white text-lg" />
                  </div>
                  <span className="text-primary">
                    Informasi Audit
                  </span>
                </h3>
                <div className="grid grid-cols-1 gap-4 tablet:grid-cols-2 xl:grid-cols-3">
                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                      <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                      Tanggal Audit *
                    </label>
                    <Calendar
                      name="tgl"
                      value={form.tgl ? new Date(form.tgl) : null}
                      onChange={(e) => {
                        const date = e.value ? e.value.toISOString().split('T')[0] : '';
                        setForm(prev => ({ ...prev, tgl: date }));
                      }}
                      dateFormat="dd/mm/yy"
                      showIcon
                      appendTo={document.body}
                      inputClassName="sip-input"
                      className={`w-full ${errors.tgl ? "p-invalid" : ""}`}
                    />
                    {errors.tgl && (
                      <small className="p-error text-red-600 font-medium">{errors.tgl}</small>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                      <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                      Lokasi *
                    </label>
                    <Dropdown
                      name="lokasi"
                      value={form.lokasi || ""}
                      onChange={handleInputChange}
                      options={lokasiOptions}
                      placeholder="Pilih lokasi"
                      appendTo={document.body}
                      className={`w-full ${errors.lokasi ? "p-invalid" : ""}`}
                    />
                    {errors.lokasi && (
                      <small className="p-error text-red-600 font-medium">{errors.lok}</small>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                      <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                      Petugas *
                    </label>
                    <InputText
                      name="petugas"
                      value={form.petugas || ""}
                      onChange={handleInputChange}
                      className={`w-full p-4 rounded-xl border-2 transition-all duration-300 ${errors.petugas ? 'p-invalid border-red-300' : 'border-gray-200 focus:border-purple-500 focus:ring-4 focus:ring-purple-100'}`}
                      placeholder="Nama petugas audit"
                    />
                    {errors.petugas && (
                      <small className="p-error text-red-600 font-medium">{errors.petugas}</small>
                    )}
                  </div>
                </div>
              </div>

              {/* Proses Audit */}
              <div className="rounded-2xl border border-slate-100 bg-white p-4 shadow-sm sm:p-5">
                <h3 className="mb-4 flex items-center gap-3 text-base font-semibold text-slate-800">
                  <div className="p-3 bg-warning rounded-xl">
                    <FaShieldAlt className="text-white text-lg" />
                  </div>
                  <span className="text-warning">
                    Proses Audit Keamanan
                  </span>
                </h3>

                <div className="grid grid-cols-1 gap-4 tablet:grid-cols-2 xl:grid-cols-3">
                  {/* ==================== ANTIVIRUS ==================== */}
                  <div className="rounded-xl border border-slate-100 bg-slate-50 p-4">
                    <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-3">
                      <div className="p-2 bg-danger rounded-lg">
                        <FaVirus className="text-white text-sm" />
                      </div>
                      <span className="text-danger">
                        Antivirus
                      </span>
                    </h4>

                    <div className="space-y-4">
                      {/* Status Antivirus - Radio */}
                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                          <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                          Status Antivirus *
                        </label>
                        <div className="flex flex-col gap-2">
                          <div className="flex items-center gap-3 p-3 rounded-lg hover:bg-red-50 transition-all duration-200 cursor-pointer"
                               onClick={() => handleAntivirusStatus('ada')}>
                            <RadioButton
                              checked={getMainStatus('antivirus') === 'ada'}
                              onChange={() => handleAntivirusStatus('ada')}
                            />
                            <span className="text-sm font-medium text-gray-700">Ada</span>
                          </div>
                          <div className="flex items-center gap-3 p-3 rounded-lg hover:bg-red-50 transition-all duration-200 cursor-pointer"
                               onClick={() => handleAntivirusStatus('tidak_ada')}>
                            <RadioButton
                              checked={form2.antivirus === 'tidak_ada'}
                              onChange={() => handleAntivirusStatus('tidak_ada')}
                            />
                            <span className="text-sm font-medium text-gray-700">Tidak Ada</span>
                          </div>
                        </div>
                      </div>

                      {/* Update Status - hanya muncul jika antivirus ada */}
                      {getMainStatus('antivirus') === 'ada' && (
                        <div>
                          <label className="block text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                            Status Update *
                          </label>
                          <div className="flex flex-col gap-2">
                            <div className="flex items-center gap-3 p-3 rounded-lg hover:bg-green-50 transition-all duration-200 cursor-pointer"
                                 onClick={() => handleAntivirusUpdate('terupdate')}>
                              <RadioButton
                                checked={hasValue('antivirus', 'terupdate')}
                                onChange={() => handleAntivirusUpdate('terupdate')}
                              />
                              <FaCheck className="text-green-600 text-sm" />
                              <span className="text-sm font-medium text-gray-700">Terupdate</span>
                            </div>
                            <div className="flex items-center gap-3 p-3 rounded-lg hover:bg-red-50 transition-all duration-200 cursor-pointer"
                                 onClick={() => handleAntivirusUpdate('tidak_terupdate')}>
                              <RadioButton
                                checked={hasValue('antivirus', 'tidak_terupdate')}
                                onChange={() => handleAntivirusUpdate('tidak_terupdate')}
                              />
                              <FaTimesIcon className="text-red-600 text-sm" />
                              <span className="text-sm font-medium text-gray-700">Tidak Terupdate</span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* ==================== FIREWALL ==================== */}
                  <div className="rounded-xl border border-slate-100 bg-slate-50 p-4">
                    <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-3">
                      <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-white">
                        <FaShieldAlt className="text-sm" />
                      </div>
                      <span className="text-primary">
                        Firewall
                      </span>
                    </h4>

                    <div className="space-y-4">
                      {/* Status Firewall - Radio */}
                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                          <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                          Status Firewall *
                        </label>
                        <div className="flex flex-col gap-2">
                          <div className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-50 transition-all duration-200 cursor-pointer"
                               onClick={() => handleFirewallStatus('ada')}>
                            <RadioButton
                              checked={getMainStatus('firewall') === 'ada'}
                              onChange={() => handleFirewallStatus('ada')}
                            />
                            <span className="text-sm font-medium text-gray-700">Ada</span>
                          </div>
                          <div className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-50 transition-all duration-200 cursor-pointer"
                               onClick={() => handleFirewallStatus('tidak_ada')}>
                            <RadioButton
                              checked={form2.firewall === 'tidak_ada'}
                              onChange={() => handleFirewallStatus('tidak_ada')}
                            />
                            <span className="text-sm font-medium text-gray-700">Tidak Ada</span>
                          </div>
                        </div>
                      </div>

                      {/* Update Status - hanya muncul jika firewall ada */}
                      {getMainStatus('firewall') === 'ada' && (
                        <div>
                          <label className="block text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                            Status Update *
                          </label>
                          <div className="flex flex-col gap-2">
                            <div className="flex items-center gap-3 p-3 rounded-lg hover:bg-green-50 transition-all duration-200 cursor-pointer"
                                 onClick={() => handleFirewallUpdate('terupdate')}>
                              <RadioButton
                                checked={hasValue('firewall', 'terupdate')}
                                onChange={() => handleFirewallUpdate('terupdate')}
                              />
                              <FaCheck className="text-green-600 text-sm" />
                              <span className="text-sm font-medium text-gray-700">Terupdate</span>
                            </div>
                            <div className="flex items-center gap-3 p-3 rounded-lg hover:bg-red-50 transition-all duration-200 cursor-pointer"
                                 onClick={() => handleFirewallUpdate('tidak_terupdate')}>
                              <RadioButton
                                checked={hasValue('firewall', 'tidak_terupdate')}
                                onChange={() => handleFirewallUpdate('tidak_terupdate')}
                              />
                              <FaTimesIcon className="text-red-600 text-sm" />
                              <span className="text-sm font-medium text-gray-700">Tidak Terupdate</span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* ==================== PASSWORD / ENKRIPSI ==================== */}
                  <div className="rounded-xl border border-slate-100 bg-slate-50 p-4">
                    <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-3">
                      <div className="p-2 bg-primary/80 rounded-lg">
                        <FaLock className="text-white text-sm" />
                      </div>
                      <span className="text-primary">
                        Password/Enkripsi
                      </span>
                    </h4>

                    <div className="space-y-4">
                      {/* Status Password - Radio */}
                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                          <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                          Menggunakan Password *
                        </label>
                        <div className="flex flex-col gap-2">
                          <div className="flex items-center gap-3 p-3 rounded-lg hover:bg-purple-50 transition-all duration-200 cursor-pointer"
                               onClick={() => handleEnkripsiStatus('ya')}>
                            <RadioButton
                              checked={getMainStatus('enkripsi') === 'ya'}
                              onChange={() => handleEnkripsiStatus('ya')}
                            />
                            <span className="text-sm font-medium text-gray-700">Ya</span>
                          </div>
                          <div className="flex items-center gap-3 p-3 rounded-lg hover:bg-purple-50 transition-all duration-200 cursor-pointer"
                               onClick={() => handleEnkripsiStatus('tidak')}>
                            <RadioButton
                              checked={form2.enkripsi === 'tidak'}
                              onChange={() => handleEnkripsiStatus('tidak')}
                            />
                            <span className="text-sm font-medium text-gray-700">Tidak</span>
                          </div>
                        </div>
                      </div>

                      {/* Kekuatan Password - hanya muncul jika menggunakan password */}
                      {getMainStatus('enkripsi') === 'ya' && (
                        <div>
                          <label className="block text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                            Kekuatan Password *
                          </label>
                          <div className="flex flex-col gap-2">
                            <div className="flex items-center gap-3 p-3 rounded-lg hover:bg-green-50 transition-all duration-200 cursor-pointer"
                                 onClick={() => handleEnkripsiStrength('kuat')}>
                              <RadioButton
                                checked={hasValue('enkripsi', 'kuat')}
                                onChange={() => handleEnkripsiStrength('kuat')}
                              />
                              <span className="text-sm font-medium text-gray-700">Kuat</span>
                            </div>
                            <div className="flex items-center gap-3 p-3 rounded-lg hover:bg-red-50 transition-all duration-200 cursor-pointer"
                                 onClick={() => handleEnkripsiStrength('lemah')}>
                              <RadioButton
                                checked={hasValue('enkripsi', 'lemah')}
                                onChange={() => handleEnkripsiStrength('lemah')}
                              />
                              <span className="text-sm font-medium text-gray-700">Lemah</span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* ==================== UPDATE SO ==================== */}
                  <div className="rounded-xl border border-slate-100 bg-slate-50 p-4">
                    <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-3">
                      <div className="p-2 bg-primary/80 rounded-lg">
                        <FaDesktop className="text-white text-sm" />
                      </div>
                      <span className="text-primary">
                        Update Sistem Operasi
                      </span>
                    </h4>

                    <div className="space-y-4">
                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                          <div className="w-2 h-2 bg-indigo-500 rounded-full"></div>
                          Status Update SO *
                        </label>
                        <div className="flex flex-col gap-2">
                          <div className="flex items-center gap-3 p-3 rounded-lg hover:bg-indigo-50 transition-all duration-200 cursor-pointer"
                               onClick={() => handleSoUpdateStatus('ya')}>
                            <RadioButton
                              checked={form2.so_update === 'ya'}
                              onChange={() => handleSoUpdateStatus('ya')}
                            />
                            <FaCheck className="text-green-600 text-sm" />
                            <span className="text-sm font-medium text-gray-700">Ya (Terupdate)</span>
                          </div>
                          <div className="flex items-center gap-3 p-3 rounded-lg hover:bg-indigo-50 transition-all duration-200 cursor-pointer"
                               onClick={() => handleSoUpdateStatus('tidak')}>
                            <RadioButton
                              checked={form2.so_update === 'tidak'}
                              onChange={() => handleSoUpdateStatus('tidak')}
                            />
                            <FaTimesIcon className="text-red-600 text-sm" />
                            <span className="text-sm font-medium text-gray-700">Tidak (Belum Update)</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ==================== ORIGINAL SOFTWARE ==================== */}
                  <div className="rounded-xl border border-slate-100 bg-slate-50 p-4">
                    <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-3">
                      <div className="p-2 bg-accent rounded-lg">
                        <FaCompactDisc className="text-white text-sm" />
                      </div>
                      <span className="text-accent-600">
                        Software Original
                      </span>
                    </h4>

                    <div>
                      <label className="block text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                        <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                        Daftar Software Original
                      </label>
                      <InputTextarea
                        name="original_soft"
                        value={form2.original_soft || ""}
                        onChange={handleForm2Change}
                        rows={4}
                        className="w-full p-4 rounded-xl border-2 border-gray-200 focus:border-green-500 focus:ring-4 focus:ring-green-100 transition-all duration-300"
                        placeholder="Masukkan daftar software original yang terinstall, contoh:&#10;- Microsoft Office 2021&#10;- Adobe Acrobat Reader&#10;- Google Chrome&#10;- Windows Defender"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Catatan */}
              <div className="rounded-2xl border border-slate-100 bg-white p-4 shadow-sm sm:p-5">
                <h3 className="mb-4 flex items-center gap-3 text-base font-semibold text-slate-800">
                  <div className="p-3 bg-warning rounded-xl">
                    <FaFileAlt className="text-white text-lg" />
                  </div>
                  <span className="text-warning">
                    Catatan Audit
                  </span>
                </h3>
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                    <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                    Catatan (Opsional)
                  </label>
                  <InputTextarea
                    name="hasil"
                    value={form2.hasil || ""}
                    onChange={handleForm2Change}
                    rows={4}
                    className="w-full p-4 rounded-xl border-2 border-gray-200 focus:border-orange-500 focus:ring-4 focus:ring-orange-100 transition-all duration-300"
                    placeholder="Masukkan catatan tambahan mengenai hasil audit keamanan..."
                  />
                </div>
              </div>

              {/* Action Buttons */}
            </form>
        </div>
      </Dialog>
    </>
  );
}

export default AddAudit;